module.exports = __webpack_public_path__ + "static/img/jc_zt_sec2_img2.c69f558.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceThree/jc_zt_sec2_img2.jpg
// module id = C7F5
// module chunks = 171